import { debounce } from 'lodash';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styles/styled-components';
import { ApplicationRootState } from 'types';
import { CategoryDetail } from 'types/schema';
import media from 'utils/mediaStyle';
import { setApplyFilter } from '../actions';
import messages from '../messages';
import { selectCategories } from '../selectors';

const CategoriesContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;

  ${media.md`
    flex-wrap: wrap;
    
    `}
`;

const CategoryItem = styled.div`
  padding: 6px 12px;
  border-radius: 20px;
  background: #ffffff;

  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;

  cursor: pointer;
  ${(props) =>
    props.isSelected
      ? 'border: 1px solid #43a047; color: #43A047; font-weight: 500;'
      : 'border: 1px solid #f1f1f1; color: #343538; font-weight: 400;'}

  &:hover {
    border-color: #43a047;
  }
`;
export interface IStateProps {
  categories: CategoryDetail[];
}

interface DispatchProps {
  onFilterProduct: (categoryIds?: number) => void;
}

type Props = IStateProps & DispatchProps;

const Categories: FC<Props> = (props) => {
  const [selectedCategory, setSelectedCategory] = useState<number>();

  const { categories, onFilterProduct } = props;

  return (
    <CategoriesContainer>
      <CategoryItem
        isSelected={!selectedCategory}
        key="all"
        onClick={() => {
          setSelectedCategory(undefined);
          onFilterProduct();
        }}
      >
        <FormattedMessage {...messages.all} defaultMessage="Tất cả" />
      </CategoryItem>
      {categories.map((category) => (
        <CategoryItem
          isSelected={selectedCategory === category.id}
          key={category.id}
          onClick={debounce(() => {
            if (selectedCategory === category.id) {
              setSelectedCategory(undefined);
              onFilterProduct(undefined);
            } else {
              setSelectedCategory(category.id || undefined);
              onFilterProduct(category.id || undefined);
            }
          }, 300)}
        >
          {category.name}
        </CategoryItem>
      ))}
    </CategoriesContainer>
  );
};

const mapStateToProps = createStructuredSelector<ApplicationRootState, IStateProps>({
  categories: selectCategories(),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onFilterProduct: (categoryId?: number) =>
      dispatch(
        setApplyFilter({
          categoryId: categoryId,
        }),
      ),
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(Categories);
